import React from "react";
import Hero from "./Hero";
import Projects from "./Projects/Projects";
import Experience from "./Experience";
import Blog from "./Blog";
import Education from "./Education";
import FadeInSection from "./FadeInSection";

export default function Home() {
  return (
    <>
      <FadeInSection>
        <Hero />
      </FadeInSection>
      <FadeInSection>
        <Projects />
      </FadeInSection>
      <FadeInSection>
        <Experience />
      </FadeInSection>
      <FadeInSection>
        <Blog />
      </FadeInSection>
      <FadeInSection>
        <Education />
      </FadeInSection>
    </>
  );
}
